import type z from 'zod';
import { sectionContextSchema } from './section-context-schema';

/**
 * Form schema for creating/editing a section. A section's editable fields are
 * exactly the shared "section context" (see {@link sectionContextSchema}); tree
 * placement (parent/sibling) and user assignments are managed elsewhere.
 */
export const sectionFormSchema = sectionContextSchema;

export type SectionFormValues = z.input<typeof sectionFormSchema>;
export type SectionFormValidated = z.output<typeof sectionFormSchema>;
